<div class="alert alert-secondary" role="alert">
  <h4 class="alert-heading row align-items-center"><mat-icon class="me-2">info</mat-icon> {{heading}}</h4>
  <hr>
  <ng-content></ng-content>
</div>